'use client';
import { browserAction } from './utils/browserAction.js';
import { createPrefixer } from './utils/prefixer.js';

var identsRegistryPrefixer = createPrefixer("#ir.");
/**
 * SSR-безопасная обёртка над sessionStorage,
 * обеспечивающая персистентное хранение ключей динамических идентификаторов кэша.
 **/ var identsRegistry = {
    resolve: browserAction(function(key) {
        var value = window.sessionStorage.getItem(identsRegistryPrefixer.prefixed(key));
        return value ? JSON.parse(value) : null;
    }),
    persist: browserAction(function(key, ident) {
        window.sessionStorage.setItem(identsRegistryPrefixer.prefixed(key), JSON.stringify(ident));
    })
};

export { identsRegistry };
